<template>
  <div class="select-sort">
    <div class="select-sort__head" @click="changeOpen">
      <span>{{ valueLabel }}</span>
      <img
        src="~/assets/img/svg/common/arrow-down.svg"
        alt="развернуть"
      />
    </div>
    <template v-if="isOpen">
      <div class="select-sort__dropdown">
        <div
          v-for="(option, index) in options"
          :key="`option-${index}`"
          class="h5"
          @click="() => changeValue(option.value)"
        >
          {{ option.label }}
        </div>
      </div>
      <div class="select-sort__close" @click="changeOpen"/>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';

const props = defineProps({
  value: {
    type: String,
    default: ""
  },
  options: {
    type: Object as PropType<any>,
  }
});
const emit = defineEmits(['change']);

const isOpen = ref(false);

const valueLabel = computed(() => {
  return props.options.find((t: any) => t.value === props.value)?.label
})

const changeOpen = () => {
  isOpen.value = !isOpen.value;
};
const changeValue = (value: string) => {
  emit('change', value);
  isOpen.value = false;
}
</script>

<style lang="scss" scoped>
.select-sort {
  position: relative;
}
.select-sort__head {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #000;
  font-size: 16px;
  font-weight: 500;
  line-height: 100%;

  img {
    width: 20px;
    height: 20px;
    margin-left: 3px;
  }
}
.select-sort__dropdown {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: calc(100% + 4px); right: 0;
  border-radius: 16px;
  border: 1px solid #B8B8B8;
  background: #FFF;
  padding: 4px 0;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 25;

  & > * {
    padding: 4px 16px;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      background-color: #F4F4F4;
    }
  }
}
.select-sort__close {
  position: fixed;
  inset: 0;
  z-index: 24;
}

@media (max-width: 1023px) {
  .select-sort__head {
    font-size: 12px;
  }
}
</style>
